import { Avatar, AvatarFallback } from "../ui/avatar";
import { BookOpen, Circle } from "lucide-react";

const onlineFriends = [
{ name: "Kamran H.", initials: "KH", reading: "Calculus II — Chapter 9", status: "online" },
{ name: "Sabina R.", initials: "SR", reading: "Microeconomics Notes", status: "online" },
{ name: "Elvin M.", initials: "EM", reading: null, status: "online" },
{ name: "Farid G.", initials: "FG", reading: "Physics Lab Report", status: "idle" },
{ name: "Aysel H.", initials: "AH", reading: "Marketing 101 — Slides", status: "online" }];


const OnlineFriendsSidebar = () => {
  const online = onlineFriends.filter((f) => f.status === "online");
  const idle = onlineFriends.filter((f) => f.status === "idle");

  return (
    <div className="stat-card !p-4">
      <h3 className="text-sm font-display font-bold text-foreground mb-3 flex items-center gap-2">
        <Circle className="w-3 h-3 text-success fill-success" />
        Online Now ({online.length + idle.length})
      </h3>
      <div className="space-y-2">
        {[...online, ...idle].map((f, i) =>
        <div key={i} className="flex items-center gap-2.5 p-2 rounded-xl hover:bg-muted/50 transition-colors cursor-pointer">
            <div className="relative">
              <Avatar className="w-8 h-8">
                <AvatarFallback className="bg-primary/10 text-primary text-[10px] font-bold">{f.initials}</AvatarFallback>
              </Avatar>
              <div className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-card ${
            f.status === "online" ? "bg-success" : "bg-chart-4"}`
            } />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium text-foreground truncate">{f.name}</p>
              {f.reading ?
            <p className="text-[10px] text-muted-foreground truncate flex items-center gap-1">
                  <BookOpen className="w-2.5 h-2.5 flex-shrink-0" /> {f.reading}
                </p> :

            <p className="text-[10px] text-muted-foreground">Browsing</p>
            }
            </div>
          </div>
        )}
      </div>
    </div>);

};

export default OnlineFriendsSidebar;